import Enum from "./Enum";

const EnumCountry = new Enum({
    UAE: {name: "UAE", currency: "AED", fractionDigits: 2},
    KUWAIT: {name: "Kuwait", currency: "KWD", fractionDigits: 3}
});

export default EnumCountry;